import { render, staticRenderFns } from "./Contexto.vue?vue&type=template&id=6ac4ed19&scoped=true&"
import script from "./Contexto.js?vue&type=script&lang=js&"
export * from "./Contexto.js?vue&type=script&lang=js&"
import style0 from "./Contexto.scss?vue&type=style&index=0&id=6ac4ed19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac4ed19",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnswersTable: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/games/AnswersTable.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
